import { graphql } from 'gatsby';
import { VideoPlayer, Heading } from 'lucid-components-react';
import React, { useContext, useState } from 'react';

import ReactHtmlParser from 'react-html-parser';
import LayoutContext from '../../../contexts/layoutContext';
import { Drupal_ParagraphNineteenHeroImage } from '../../../generated/graphql';
import NineteenAction from '../nineteen-action/nineteen-action';
import './nineteen-hero-image.scss';

interface Props {
  entity: Drupal_ParagraphNineteenHeroImage;
}

const NineteenHeroImage = ({
  entity: {
    fieldHeader,
    fieldHeaderPiece,
    fieldSubheader,
    fieldImage,
    fieldVideoLink,
    fieldAutoplay,
    fieldVideoInitialLoop,
    fieldNineteenAction
  }
}: Props) => {
  const {
    language: { langPrefix },
    video: { getVideoModal }
  } = useContext(LayoutContext);

  const [isEnded, setIsEnded] = useState(!fieldVideoInitialLoop);

  const getImageHtml = () =>
    fieldVideoInitialLoop ? (
      <VideoPlayer
        url={fieldVideoInitialLoop}
        playing
        muted
        ratio="square"
        playsInline
        onEnded={() => {
          setIsEnded(true);
        }}
      />
    ) : (
      <img
        className="nineteen-hero-image__image-tag"
        src={fieldImage!}
        alt={fieldHeader!}
      />
    );

  const hasHeaderPieces = fieldHeaderPiece && fieldHeaderPiece.length > 0;

  return (
    <header className="nineteen-hero-image">
      <div className="nineteen-hero-image__wrapper lucid-container">
        {fieldVideoLink ? (
          <button
            type="button"
            className={`nineteen-hero-image__image-button ${
              isEnded ? 'nineteen-hero-image__image-button--ended' : ''
            }`}
            onClick={() =>
              getVideoModal(fieldVideoLink, fieldAutoplay || false)
            }
          >
            {getImageHtml()}
          </button>
        ) : (
          <div className="nineteen-hero-image__image">{getImageHtml()}</div>
        )}

        <div
          className={`nineteen-hero-image__content ${
            langPrefix !== 'en'
              ? 'nineteen-hero-image__content--full-width'
              : ''
          }`}
        >
          <Heading>
            {hasHeaderPieces
              ? ReactHtmlParser(fieldHeaderPiece!.join('<br/>'))
              : fieldHeader}
          </Heading>
          <p className="nineteen-hero-image__subheader">{fieldSubheader}</p>
          {fieldNineteenAction && fieldNineteenAction.entity && (
            <NineteenAction entity={fieldNineteenAction.entity} />
          )}
        </div>
      </div>
    </header>
  );
};

export default NineteenHeroImage;

export const query = graphql`
  fragment nineteenHeroImage on Drupal_ParagraphNineteenHeroImage {
    fieldHeader
    fieldHeaderPiece
    fieldSubheader
    fieldImage
    fieldVideoInitialLoop
    fieldVideoLink
    fieldAutoplay
    fieldNineteenAction {
      entity {
        ...nineteenAction
      }
    }
  }
`;
